{
	"layout": {
		"line-cap": "square"
	},
	"paint": {
		"line-color": "#03A9F4",
		"line-width": ["interpolate", ["linear"], ["zoom"], 9, 2, 18, 12],
		"line-blur": 1,
		"line-opacity": 1,
		"line-dasharray": ["match", ["get", "road_seal"], 1, ["literal", [1, 0]], ["literal", [2, 1]]]
	}
}
